import React from "react";
import {
  ContactForm7IntegrationPageStyled
  // ArrowSeparatorStyled,
  // ConnectorWrapperStyled
} from "./styled";
import {
  Typography,
  Layout,
  Select,
  Icon,
  Table,
  Button,
  Form,
  Popconfirm,
  message
} from "antd";
import { observer, inject } from "mobx-react";
import { observable, action, computed } from "mobx";
import Api from "../../../services/Api";
import { FormComponentProps } from "antd/lib/form";

const { Header } = Layout;
const { Title } = Typography;
const { Option } = Select;

interface Props extends FormComponentProps {
  api?: Api;
}

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 }
};

interface FormData {
  key: string;
  id: string;
  title: string;
}

@inject("api")
@observer
class ContactForm7IntegrationPage extends React.PureComponent<Props, any> {
  /**
   * Hold Contact form 7 post type - 'wpcf7_contact_form'
   */
  @observable CF7Forms: FormData[] = [];
  @observable templates: any[] = [];
  @observable integrations: any[] = [];
  @observable loading: boolean = false;
  @observable rowIdLoading: number | null = null;

  @action setCF7Forms = (forms: FormData[]) => {
    this.CF7Forms = forms;
  };

  @action setTemplates = (templates: any[]) => {
    this.templates = templates;
  };

  @action setIntegrations = (integrations: any[]) => {
    this.integrations = integrations;
  };

  @action addIntegration = (integration: any) => {
    this.integrations.push(integration);
  };

  @action setRowIdLoading = (id: number | null) => {
    this.rowIdLoading = id;
  };

  @computed get formWithoutInteractions() {
    return this.CF7Forms.reduce((accumulator: any, form: any) => {
      const integrationForm = this.integrations.filter(
        (integration: any) =>
          Number(integration.cf7_post_id) === Number(form.id)
      );
      if (!integrationForm.length) {
        accumulator.push(form);
      }
      return accumulator;
    }, []);
  }
  componentDidMount = () => {
    this.fetchInitData();
  };

  fetchInitData = async () => {
    this.loading = true;
    const responseFormsPromise: any = this.props.api?.getCF7Forms();
    const responseIntegrationsPromise: any = this.props.api?.getCF7Integrations();
    const responseTemplatePromise: any = this.props.api?.getTemplates(
      0,
      10000000
    );
    const responseForms = await responseFormsPromise;
    const responseTemplates = await responseTemplatePromise;
    const responseIntegrations = await responseIntegrationsPromise;

    if (responseIntegrations.data.integrations) {
      const integrations = responseIntegrations.data.integrations.map(
        (integration: any) => {
          integration.key = integration.id;
          return integration;
        }
      );
      this.setIntegrations(integrations);
    }

    if (responseTemplates.data.templates) {
      this.setTemplates(responseTemplates.data.templates);
    }

    if (responseForms.data.posts) {
      const forms: FormData[] = responseForms.data.posts.map((post: any) => ({
        key: post.ID,
        id: post.ID,
        title: post.post_title
      }));

      this.setCF7Forms(forms);

      this.loading = false;
    }
  };

  handleCreateInteractionSubmit = async (event: any) => {
    event.preventDefault();
    let integration: any = {};
    this.props.form.validateFields((err, values) => {
      if (!err) {
        integration = Object.assign(integration, values);
      }
    });

    if (!integration.cf7_post_id) {
      return;
    }

    const key = Math.random();

    message.loading({ content: "Creating...", key });
    const response = await this.props.api?.createOrUpdateCF7Integration(
      integration
    );

    if (response?.data.integration) {
      response.data.integration.key = response.data.integration.id;
      this.addIntegration(response?.data.integration);
      if (response?.status === 200) {
        message.success({
          content: `Integration successfully added.`,
          key,
          duration: 1.5
        });
      }
    }
  };

  @action handleRowValueChange = async (changes: any, integration: any) => {
    integration = Object.assign(integration, changes);
    const key = Math.random();

    message.loading({ content: "Updating...", key });
    const response = await this.props.api?.createOrUpdateCF7Integration(
      integration
    );

    if (response?.status === 200) {
      message.success({
        content: `Integration successfully updated.`,
        key,
        duration: 1.5
      });
    }
  };

  onChange = (value: any) => {
    console.log(`selected ${value}`);
  };

  onBlur = () => {
    // console.log("blur");
  };

  onFocus = () => {
    // console.log("focus");
  };

  onSearch = (val: any) => {
    console.log("search:", val);
  };

  onDelete = async (id: number) => {
    this.setRowIdLoading(id);
    const key = Math.random();
    message.loading({ content: "Deleting...", key });
    const response: any = await this.props.api?.deleteCF7Integration(id);
    if (response?.data?.success) {
      const integrations = this.integrations.filter(i => i.id !== id);
      this.setIntegrations(integrations);
      message.success({ content: "Deleted successfully!", key, duration: 1.5 });
    }

    this.rowIdLoading = null;
  };

  columns = [
    {
      title: "Name",
      dataIndex: "post_title",
      key: "title"
    },
    {
      title: "User's template (Mail2)",
      dataIndex: "user_template_id",
      key: "users_template",
      render: (...args: any[]) => (
        <Select
          showSearch
          defaultValue={args[1].user_template_id}
          style={{ width: 200 }}
          placeholder="Select a template"
          optionFilterProp="children"
          onChange={(value: any) => {
            const row = args[1];
            this.handleRowValueChange({ user_template_id: value }, row);
          }}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}
          filterOption={(input: any, option: any) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          <Option value={""} >
            Choose template
          </Option>
          {this.templates.map((template: any) => (
            <Option value={template.id} key={`${template.id}`}>
              {template.name}
            </Option>
          ))}
        </Select>
      )
    },
    {
      title: "Admin's template (Mail)",
      dataIndex: "admin_template_id",
      key: "admin_template",
      render: (...args: any[]) => {
        return (
          <Select
            showSearch
            defaultValue={args[1].admin_template_id}
            style={{ width: 200 }}
            placeholder="Select a template"
            optionFilterProp="children"
            onChange={(value: any) => {
              const row = args[1];
              this.handleRowValueChange({ admin_template_id: value }, row);
            }}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onSearch={this.onSearch}
            filterOption={(input: any, option: any) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value={""} >
              Choose template
            </Option>
            {this.templates.map((template: any) => (
              <Option value={`${template.id}`} key={`${template.id}`}>
                {template.name}
              </Option>
            ))}
          </Select>
        );
      }
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      // render: () => {
      //   return <Button type="danger">Delete</Button>;
      // },
      render: (...args: any) => {
        return (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              this.onDelete(args[1].key);
            }}
          >
            <Button
              type="danger"
              loading={Number(args[1].id) === this.rowIdLoading}
              icon={"delete"}
            >
              delete
            </Button>
          </Popconfirm>
        );
      }
    }
  ];

  isValidForm = () => {
    const {
      form: { isFieldValidating }
    } = this.props;
    console.log(isFieldValidating("cf7_post_id"));
    return true;
  };

  render() {
    const {
      form: { getFieldDecorator }
    } = this.props;

    const buttonItemLayout = {
      wrapperCol: { span: 14, offset: 4 }
    };

    return (
      <ContactForm7IntegrationPageStyled>
        <Header style={{ background: "#fff", padding: "0", height: "inherit" }}>
          <Title level={3}>Contact form 7</Title>
          <Title level={4} style={{ color: "#a7a7a7", margin: "0 0 38px" }}>
            It lets you customize the contact form email both for users and
            admin.
          </Title>
        </Header>

        <Form onSubmit={this.handleCreateInteractionSubmit}>
          <Form.Item {...formItemLayout} label="Select Form">
            {getFieldDecorator("cf7_post_id", {
              rules: [
                {
                  required: true,
                  message: "Please select form"
                }
              ]
            })(
              <Select
                showSearch
                style={{ width: 200 }}
                placeholder="Select a form"
                optionFilterProp="children"
                onChange={this.onChange}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onSearch={this.onSearch}
                filterOption={(input: any, option: any) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {this.formWithoutInteractions.map((form: FormData) => (
                  <Option value={`${form.id}`} key={`${form.id}`}>
                    {form.title}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
          <Form.Item {...buttonItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={!this.isValidForm()}
            >
              <Icon type="plus" /> Create interaction
            </Button>
          </Form.Item>
        </Form>

        <Table
          dataSource={this.integrations}
          columns={this.columns}
          bordered
          loading={this.loading}
        />
      </ContactForm7IntegrationPageStyled>
    );
  }
}
export default Form.create({ name: "ContactForm7IntegrationPage" })(
  ContactForm7IntegrationPage
);
